import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Link } from 'react-router-dom';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import Select from 'react-select';

import ScheduleGradeStaffChangeModal from './Elements/ScheduleGradeStaffChangeModal';
import ScheduleGradeStaffVacationModal from './Elements/ScheduleGradeStaffVacationModal';

class SchedulesChangeSimulation extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      modal: false,
      modal_vacation: false,
      redirect_url: false,
      loaded: 0,
      name: '',
      base_id: null,
      date_start: '',
      date_finish: '',
      schedule_grade_group_staffs: [],
      grade_period_list: [],
      roles_list: [],
      schedule_grade_group_staff_periods: [],
      schedule_grade_group_staff_list_fixed: [],
      schedule_grade_group_staff_list: [],
      schedule_grade_groups_list: [],
      schedule_grades_list: [],
      modal_periods_list: [],
      periods_list: [],
      schedule_grade_ids: [],
      schedule_grade_group_ids: [],
      staff_ids: [],
      schedule_grade_group_staff: null,
      schedule_grade_group_staff_periods: null,
      modal_staff: null,
      modal_group: null,
      modal_transfered: null,
      modal_schedule_period_id: null,
      schedule_grade_group_staff_id: null,
      regimes_list: [],
      
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.search = this.search.bind(this);
    this.loadData = this.loadData.bind(this);
    this.loadGroupsInfo = this.loadGroupsInfo.bind(this);
    this.loadStaffsInfo = this.loadStaffsInfo.bind(this);
    this.openModal = this.openModal.bind(this);
    this.openVacationModal = this.openVacationModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.actionButton = this.actionButton.bind(this);
    this.updateData = this.updateData.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChangeModal(name, index, event) {
    var change = this.state.schedule_grade_group_staff_periods;
    if(event == null) {
      change[index][name] = null;
    } else {
      change[index][name] = event.value;
    }
    this.setState({schedule_grade_group_staff_periods: change});
  }

  handleChangeModal (name, index, event) {
    var change = this.state.schedule_grade_group_staff_periods;
    change[index][name] = event.target.value;
    this.setState({schedule_grade_group_staff_periods: change});
  }
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectChangeMulti(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  handleSelectChangeGrade(name, event) {
    var change = {};
    if(event.length == 0) {
      change[name] = null;
      change['schedule_grade_groups_list'] = null;
      change['schedule_grade_group_staff_list'] = null;
      change['schedule_grade_group_staff_list_fixed'] = null;
      change['schedule_grade_group_ids'] = null;
      change['schedule_grade_group_staff_ids'] = null;
    } else {
      change[name] = event;
      this.loadGroupsInfo(event);
    }
    this.setState(change);
  }  


  handleSelectChangeGroup(name, event) {
    var change = {};
    if(event.length == 0) {
      change[name] = null;
      change['schedule_grade_group_staff_list'] = this.state.schedule_grade_group_staff_list_fixed;
    } else {
      change[name] = event;
      this.loadStaffsInfo(event);
    }
    this.setState(change);

  }  


  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  closeModal() {
    this.setState({
      modal: false,
      modal_vacation: false,
      schedule_grade_group_staff_id: null,
      modal_schedule_period_id: null,
      modal_transfered: null,
      modal_group: null,
      modal_schedule_grade_group: null,
      open_schedule_grade_groups: [],
      open_schedule_grade_group_periods: [],
      period_list: [],
      group_list: [],
      staff: null,
      schedule_grade_group_staff_periods: {},
      date_start: null,
      date_finish: null,
      staff_id: null,
      modal_staff: null,
    });
  }

  actionButton (cell, row) {
    var self = this;
    if(row.group == 'Férias') {
      var botao = (
        <button onClick={self.openVacationModal.bind(self, row)} className="btn btn-primary"><i className="fa fa-fw fa-pencil"></i></button>
      );

    } else {
      var botao = (
        <button onClick={self.openModal.bind(self, cell)} className="btn btn-primary"><i className="fa fa-fw fa-pencil"></i></button>
      );
    }

    return botao;
  }


  openModal(schedule_grade_group_staff_id, event) {
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/colaborador/' + schedule_grade_group_staff_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert('', '', 'closed');
        if (responseJson.status === 'success') {
          self.setState({
            modal: true,
            schedule_grade_group_staff: responseJson.data.schedule_grade_group_staff,
            schedule_grade_group_staff_periods: responseJson.data.schedule_grade_group_staff.schedule_grade_group_staff_periods,
            modal_staff: responseJson.data.schedule_grade_group_staff.staff.name,
            modal_group: responseJson.data.schedule_grade_group_staff.schedule_grade_group_id,
            modal_transfered: responseJson.data.schedule_grade_group_staff.transfered,
            modal_schedule_period_id: responseJson.data.schedule_grade_group_staff.schedule_period_id,
            schedule_grade_group_staff_id: responseJson.data.schedule_grade_group_staff.id,
            open_schedule_grade_groups: responseJson.data.open_schedule_grade_groups,
            open_schedule_grades: responseJson.data.open_schedule_grades,
            modal_periods_list: responseJson.data.periods,
            modal_group_list: responseJson.data.groups,
          });
        }
        
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  openVacationModal(data, event) {
    this.setState({
      modal_vacation: true,
      date_start: data.date_start,
      date_finish: data.date_finish,
      staff_id: data.staff_id,
      modal_staff: data.name,
      schedule_grade_group_staff_id: data.id,
    });
  }


  loadGroupsInfo(event) {
    var datasave = {
      schedule_grade_ids: event,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escalas/grades/info', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({
            schedule_grade_groups_list: responseJson.data.schedule_grade_groups_list, 
            schedule_grade_group_staff_list: responseJson.data.schedule_grade_group_staff_list, 
            schedule_grade_group_staff_list_fixed: responseJson.data.schedule_grade_group_staff_list, 
            periods_list: responseJson.data.periods_list,
          });
        }
        self.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  loadStaffsInfo(event) {
    var datasave = {
      schedule_grade_group_ids: event,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escalas/grades/grupos/info', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({
            periods_list: responseJson.data.periods_list,
            schedule_grade_group_staff_list: responseJson.data.schedule_grade_group_staff_list
          });
        }
        self.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  
  loadData(event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/simulacao', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            schedule_grades_list: responseJson.data.schedule_grades_list, 
            roles_list: responseJson.data.roles_list,
            regimes_list: responseJson.data.regimes_list,
            schedule_grade_group_staff_list: responseJson.data.schedule_grade_group_staff_list, 
            schedule_grade_group_staff_list_fixed: responseJson.data.schedule_grade_group_staff_list, 
          });
        }
      }).then(() => {
        if (typeof event !== 'undefined') {
          self.handleAlert(event.message, event.status, 'open');
        }
      }); /* Overlay */
    });
  }

  search(event) {
    event.preventDefault();
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    var datasave = {
      role_ids: this.state.role_ids,
      schedule_grade_ids: this.state.schedule_grade_ids,
      schedule_grade_group_ids: this.state.schedule_grade_group_ids,
      periods: this.state.periods,
      regime_ids: this.state.regime_ids,
      staff_ids: this.state.staff_ids,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/simulacao/pesquisa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({
            schedule_grade_group_staffs: responseJson.data, 
          });
        }
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'closed'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  updateData (event) {
    this.loadData(event);
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-fluid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Simular alteração em escala</h3>
      <Link to="/escalas" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.search}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Escala / Grade:</label>
              <Select
                className="form-field-name"
                name="schedule_grade_ids"
                value={this.state.schedule_grade_ids}
                searchable={true}
                multi={true}
                placeholder={''}
                onChange={this.handleSelectChangeGrade.bind(this, 'schedule_grade_ids')}
                options={this.state.schedule_grades_list}
              />    
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Escala / Grupo:</label>
              <Select
                className="form-field-name"
                name="schedule_grade_group_ids"
                value={this.state.schedule_grade_group_ids}
                searchable={true}
                multi={true}
                placeholder={''}
                onChange={this.handleSelectChangeGroup.bind(this, 'schedule_grade_group_ids')}
                options={this.state.schedule_grade_groups_list}
              />    
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Grupo / Colaborador:</label>
              <Select
                className="form-field-name"
                name="schedule_grade_group_staff_ids"
                value={this.state.staff_ids}
                searchable={true}
                multi={true}
                placeholder={''}
                onChange={this.handleSelectChangeMulti.bind(this, 'staff_ids')}
                options={this.state.schedule_grade_group_staff_list}
              />    
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Regime de trabalho:</label>
              <Select
                className="form-field-name"
                name="regime_ids"
                value={this.state.regime_ids}
                searchable={true}
                multi={true}
                placeholder={''}
                onChange={this.handleSelectChangeMulti.bind(this, 'regime_ids')}
                options={this.state.regimes_list}
              />    
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Função:</label>
              <Select
                className="form-field-name"
                name="role_ids"
                value={this.state.role_ids}
                searchable={true}
                multi={true}
                placeholder={''}
                onChange={this.handleSelectChangeMulti.bind(this, 'role_ids')}
                options={this.state.roles_list}
              />    
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Período personalizado:</label>
              <Select
                className="form-field-name"
                name="periods"
                value={this.state.periods}
                searchable={true}
                multi={true}
                placeholder={''}
                onChange={this.handleSelectChangeMulti.bind(this, 'periods')}
                options={this.state.periods_list}
              />    
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-search"></i> Pesquisar</button>
          </div>
        </div>
      </form>
      <hr/>
      <BootstrapTable data={self.state.schedule_grade_group_staffs} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há escalas'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>
        <TableHeaderColumn dataField="name" width='200' dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Nome</TableHeaderColumn>
        <TableHeaderColumn dataField="inscription" width='100' isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Matrícula</TableHeaderColumn>
        <TableHeaderColumn dataField="role" width='100' dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Função</TableHeaderColumn>
        <TableHeaderColumn dataField="base" width='120' dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Base</TableHeaderColumn>
        <TableHeaderColumn dataField="group" width='100' dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Grupo</TableHeaderColumn>
        <TableHeaderColumn dataField="regime" width='100' dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Regime de Trabalho</TableHeaderColumn>
        <TableHeaderColumn dataField="period" width='200' dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Período Personalizado</TableHeaderColumn>
        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={self.actionButton} width='80'>Ações</TableHeaderColumn>
      </BootstrapTable>

      <ScheduleGradeStaffChangeModal staff={self.state.modal_staff} updateData={self.updateData} closeModal={self.closeModal} open_schedule_grade_groups={self.state.open_schedule_grade_groups} period_list={self.state.modal_periods_list} group_list={self.state.modal_group_list} schedule_grade_group_staff_periods={self.state.schedule_grade_group_staff_periods} modal_props={self.state.modal} id={self.state.schedule_grade_group_staff_id} schedule_grade_group_staff={self.state.schedule_grade_group_staff} modal_transfered={self.state.modal_transfered} modal_schedule_period_id={self.state.modal_schedule_period_id} modal_group={self.state.modal_group} open_schedule_grades={self.state.open_schedule_grades} handleAlert={self.handleAlert}/>
      
      <ScheduleGradeStaffVacationModal closeModal={self.closeModal} updateData={self.updateData} staff={self.state.modal_staff} staff_id={self.state.staff_id} date_start={self.state.date_start} date_finish={self.state.date_finish} modal_props={self.state.modal_vacation} id={self.state.schedule_grade_group_staff_id} handleAlert={self.handleAlert} />


    </div>
  </div>
</div>
    );
  }
}

export default SchedulesChangeSimulation;



// WEBPACK FOOTER //
// ./src/Components/Schedules/SchedulesChangeSimulation.js